// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"773":"dac4869d","5294":"f90b66c4"}[chunkId] + ".chunk.css";
};